import { useEffect, useState } from 'react'
import PageHead from '../../Components/PageHead';
import { getTypeWatchDelay, LogInUserID, typewatch } from '../../JS/Common';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import Popup from '../../Components/Popup';
import { CheckValidation } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import Pagination from 'react-js-pagination';
import useConfig from '../../Hooks/useConfig';

export default function ResellerStaff() {
    const { secondary_text } = useConfig();
    const [StaffMemberModal, setStaffMemberModal] = useState(false);
    const [Staffmemberaddupdateflag, setStaffmemberaddupdateflag] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [SearchForStaff, setSearchForStaff] = useState("");
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [GridData, setGridData] = useState([]);
    const [phonenoError, setphonenoError] = useState("");
    const [Groupid, setGroupid] = useState("");
    const showPagination = GridData.length > 0;
    const [staffParams, setStaffParams] = useState({
        Sortbykey: null,
        SortbyFlag: "desc"
    });

    const [staffData, setStaffData] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        groupdomain: "",
        id: 0
    })
    useEffect(() => {
        GetData(null, null);
    }, [currentPage, LimitForPagination]);
    async function GetData(SearchString, sortbykey) {
        if (!SearchString) SearchString = null;
        if (sortbykey) staffParams.SortbyFlag = staffParams.SortbyFlag == "asc" ? "desc" : "asc";
        setSearchForStaff(SearchString);
        setStaffParams({ ...staffParams, Sortbykey: sortbykey });
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/resellers/staff/list?userId=${LogInUserID}&search=${SearchString}&sortBy=${sortbykey}&sortByOrder=${staffParams.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.msg?.total)
                    setGroupid(responseRs?.reseller_group_id)
                    setGridData(responseRs.msg.data.length ? responseRs.msg.data : [])
                    setStaffData({ ...staffData, groupdomain: responseRs?.reseller_group_domain })
                }
            });
        }, getTypeWatchDelay(SearchString, 500));
    }
    function handleSearchChange(e) {
        setSearchForStaff(e.target.value)
        setCurrentPage(1);
        GetData(e.target.value, staffParams.Sortbykey);
    }
    async function handleSaveStaffMember() {
        var isFormValid = CheckValidation({ formID: 'staffmembermodal' });
        if (staffData.phoneNumber != "") {
            if (staffData.phoneNumber.length < 10 || staffData.phoneNumber.length > 10) {
                setphonenoError("Invalid Phone No.");
                isFormValid = false;
            } else {
                setphonenoError("");
            }
        }
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            uuid: Staffmemberaddupdateflag == 1 ? 0 : staffData.id,
            firstName: staffData.firstName,
            lastName: staffData.lastName,
            phoneNumber: staffData.phoneNumber,
            email: staffData.email.includes('@') ? staffData.email : staffData.email + "@" + staffData.groupdomain,
            flag: Staffmemberaddupdateflag,
            groupId: Groupid
        });
        await ApiPostCall("/resellers/staff/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var alertmsg = Staffmemberaddupdateflag == 1 ? "User Added Successfully"
                        : "User Updated Successfully";
                    setNewAlerts(
                        <AlertsComp show={true} variant="success" msg={alertmsg} />
                    );
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        setStaffMemberModal(false);
                        GetData(null, null);
                    }, 2000);
                } else {
                    setNewAlerts(
                        <AlertsComp show={true} variant="danger" msg={responseRs.message} />
                    );
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const StaffmemberBody = (
        <div className='row parent' id="staffmembermodal">
            <div className="row">
                <div className="col-md-6">
                    <div className='FormLabel'>First Name<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="firstname"
                            className="form-control" required value={staffData.firstName}
                            onChange={(e) => setStaffData({ ...staffData, firstName: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='FormLabel'>Last Name<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="lastname"
                            className="form-control" required value={staffData.lastName}
                            onChange={(e) => setStaffData({ ...staffData, lastName: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
                <div className="col-md-6 pt-3">
                    <div className='FormLabel'>Phone Number<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="number" autoComplete="off" name="phonenumber"
                            className="form-control" required value={staffData.phoneNumber}
                            onChange={(e) => setStaffData({ ...staffData, phoneNumber: e.target.value })}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                    e.preventDefault();
                                }
                            }} />
                        <span className="form-text invalid-feedback" > *required </span>
                        <span className="Emailinvalid">{phonenoError}</span>
                    </div>
                </div>
                <div className="col-md-6 pt-3">
                    <div className='FormLabel'>Email<label className='redText'>*</label></div>
                    <div className="ps-0 d-flex align-items-center">
                        <input type="text" autoComplete="off" name="email"
                            className="form-control me-2" required value={staffData.email.split('@')[0]}
                            onChange={(e) => !e.target.value.includes('@') && setStaffData({ ...staffData, email: e.target.value })} />
                        <span>@{staffData.groupdomain}</span>
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
            </div>
        </div>
    )
    async function getStaffEditData(id) {
        setLoading(true);
        await ApiGetCall(`/resellers/staff/by-id?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setStaffData({
                    ...staffData,
                    firstName: responseRs.first_name,
                    lastName: responseRs.last_name,
                    phoneNumber: responseRs.phone_number,
                    email: responseRs.email,
                    id: responseRs.id
                });
            }
        });
    }
    return (
        <>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"External Users"}
                handleSearch={handleSearchChange}
                loading={loading} Alerts={NewAlerts} showsearch={true} />
            <div className='col-12 text-end my-2'>
                <label className="BorderBtn text-center" onClick={(e) => {
                    setStaffMemberModal(true); setStaffmemberaddupdateflag(1);
                    setStaffData({ ...staffData, firstName: "", lastName: "", phoneNumber: "", email: "", id: 0 })
                }}>
                    Add User
                    <img src="/images/AddInventory.svg" className="img-fluid ps-2" />
                </label>
            </div>
            <div className="GridBox mt-2 p-3">
                <div className="col-12 greyBox mt-3 data-table-container">
                    <table className="table data-table mb-0">
                        <thead className="GridHeader">
                            <tr>
                                <th scope="col" className="cursor-pointer fw-600" onClick={(e) => GetData(SearchForStaff, "name")}>Name
                                    <img src="/images/sortbynew.svg" alt={`Sort by Name`} className="img-fluid ps-2 sortbyClass" /> </th>
                                <th scope="col" className="fw-600">Phone No.
                                </th>
                                <th scope="col" className="cursor-pointer fw-600" onClick={(e) => GetData(SearchForStaff, "email")}>Email
                                    <img src="/images/sortbynew.svg" alt={`Sort by Email`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" className=" fw-600">Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            {GridData.length != 0 ? (
                                GridData.map((item, i) => {
                                    return <tr key={i} className={`OddEvenClass tableBorderHide `}>
                                        <td className="py-12">{item.first_name} {item.last_name}</td>
                                        <td className="py-12">{item.phone_number}</td>
                                        <td className="py-12">{item.email}</td>
                                        <td className="py-12">
                                            <img src="/images/EditIconNew.svg" title={`Edit ${secondary_text} User`} className="img-fluid pe-2 cursor-pointer"
                                                onClick={(e) => {
                                                    getStaffEditData(item.id);
                                                    setStaffMemberModal(true);
                                                    setStaffmemberaddupdateflag(2);

                                                }} />
                                        </td>
                                    </tr>
                                })
                            ) : (
                                <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {showPagination && (
                    <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                )}
            </div>

            <Popup isshow={StaffMemberModal} size={"md"}
                title={Staffmemberaddupdateflag == 1 ? 'Add User' : 'Edit User'}
                closePopup={(e) => { setStaffMemberModal(false); }}
                modalBody={StaffmemberBody} handleSave={handleSaveStaffMember} visibleSaveBtn={true} btnText={
                    Staffmemberaddupdateflag == 1 ? 'Save'
                        : 'Update'
                } />

        </>
    )
}
